import {Algorithm} from "./Algorithm";
import {UserInputOptionSelector} from "./UserInputOptionSelector";

export class Hercules extends Algorithm {

  constructor(container) {
    super(container);

    this.weatherOverrides = {
      zones: {
        "1A": "sunny",
        "3C": "foggy",
        "5B": "snowing",
      }
    };
  }

  buildRangesMap() {
    this.rangesMap = this.userCombinationData.map(({key, title}, index) => {
      const value = title.split(" - ")[0];
      return {key, value, index};
    });
  }

  initUserInputs() {
    super.initUserInputs();

    this.climateZoneSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="climate_zone"]`));
    this.climateZoneSelector.on("userInputValueChanged", (value) => this.onUserInput(value));
  }

  onUserInput(value) {
    const targetCombination = this.findUserCombination(this.climateZoneSelector.getRealValue());

    // Update KPIs
    this.selectKPIs(targetCombination.key);

    // Update charts
    Object.entries(this.charts).forEach(([name, chart]) => {
      chart.loadDataset(targetCombination.index);
    });

    this.decisionLogs.update(this.currentKPIKey, this.buildingSelector.currentBuilding);

    this.sendWeatherOverride();
  }

  sendWeatherOverride() {
    if (!this.isActive) return;

    const zone = this.climateZoneSelector.getRealValue();

    app.sendScreenBridgeMessage(`weatherOverride ${this.weatherOverrides.zones[zone] ?? "none"}`);
  }

  start() {
    super.start();

    this.sendWeatherOverride();
  }

  findUserCombination(value) {
    // Let's return the entry where the value fits the correct values
    // Returns the first element if there is no match (which should not happen if data is set correctly)
    return this.rangesMap.find(entry => entry.value === value) ?? this.rangesMap[0];
  }

  resetUserInputs() {
    this.climateZoneSelector.reset();
  }

}
